import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormInstanceContactService } from "src/app/main/services/forms/form-instance-contact.service";
import { ToastService } from "src/app/main/services/toast.service";

@Component({
  selector: "app-opt-out",
  templateUrl: "./opt-out.component.html",
  styleUrls: ["./opt-out.component.scss"],
  standalone: false,
})
export class OptOutComponent implements OnInit {
  public result: string;

  constructor(
    private formInstanceContactService: FormInstanceContactService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const uuid = this.activatedRoute.snapshot.paramMap.get("uuid");
      if (uuid) {
        const response = await this.formInstanceContactService.optOut(uuid);
        this.result = <string>response.message;
      }
    } catch (error) {
      this.toastService.showError("Unable to opt out. Please try again.");
      throw error;
    }
  }

  // Helper function
}
